import { api } from '../api'

/**
 * Jobs data layer
 * 
 * Provides methods to read and manipulate tools data
 * Depends on an API module that provides HTTP methods
 * 
 * @param {object} api - API module to interact with the server
 * @param object.get - GET method
 * @param object.post - POST method
 */
const JobsAPI = () => {
    return {
        getAllJobs,
        jobDetails,
        getSequentialId,
        createJob,
        saveCookies,
        removeCookies,
        scheduleRunJob,
        runDetails,
        deleteJob,
        collectEmails,
        cancelJob,
        generateOutputs,
        dispatchJob,
        reRunJob,
        runFailedTask,
        restartTask,
        updateInputFile,
        createDynamicJob,
        runCompanyDetails,
        pauseJob,
        updateJob,
        deletejoboutput,
        reRunEmailCollection,
        taskDetails,
        deletejoboutput,
        stopSpider,
        loadall,
        saveComments,
    }

    /**
     * Retrieve a list of all jobs and their associated information
     * 
     * Information about the tool, about metrics and about logs
     */
    async function getAllJobs(limit, offset, ordering, search_by, filter_by, typeBy, toolId) {
        const jobs = await api.get(`/api/scrapery/jobs?limit=${limit}&offset=${offset}&ordering=${ordering}&type=${typeBy}&tool=${toolId}&status=${filter_by}&search=${search_by}`)

        const { results, count } = jobs

        return {
            jobs: results.map(j => ({ ...j, key: j.id })),
            count
        }
    }


    /**
     * Find a job with the given id
     * 
     * @param {number} jobId id of the job to find
     */
    async function jobDetails(jobId, page, limit, filters) {
        const url = `api/scrapery/jobs/${jobId}?page=${page}&limit=${limit}&search_by=${filters}`

        return await api.get(url)
    }

    /**
     * Get the next sequential ID for a job
     */
    async function getSequentialId() {
        const jobs = await getAllJobs()

        if (jobs || !jobs.length) {
            return 1
        }

        const jobIds = jobs.map(j => parseInt(j.id))
        const topId = Math.max(jobIds)

        return topId + 1
    }

    /**
     * Create a new job
     */
    async function createJob(job) {
        const url = "api/scrapery/jobs"

        const {
            tool,
            name,
            concurrency_factor,
            chunk_size,
            description,
            input_file,
            cookie_file,
            csrf_token,
            parameters,
        } = job

        const data = new FormData()

        data.append("tool", tool)
        data.append("name", name)
        if (concurrency_factor) {
            data.append("concurrency_factor", concurrency_factor)
        }
        data.append("description", description)

        if (chunk_size) {
            data.append("chunk_size", parseInt(chunk_size))
        }
        else {
            data.append("chunk_size", 10)
        }

        if (input_file) {
            data.append("input_file", input_file.originFileObj)
        }

        if (cookie_file) {
            data.append("cookie_file", cookie_file.originFileObj)
        }

        if (csrf_token) {
            data.append("csrf_token", `ajax:${csrf_token}`)
        }

        if (parameters) {
            data.append("params", JSON.stringify(parameters))
        }

        console.log(data)
        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Update this job input file 
     * 
     * @param {number} jobId job id to update
     * @param {File} input_file new input file
     */
    async function updateInputFile(jobId, input_file) {
        const url = `api/scrapery/jobs/${jobId}`
        const data = new FormData()

        data.append('input_file', input_file.originFileObj)

        return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Save cookies to job tables
     */
    async function saveCookies(jobId, cookeStirng) {
        const url = `api/scrapery/job-cookies/${jobId}`

        const data = new FormData()
        data.append("cookies", cookeStirng)

        return await api.post(url, data)
    }

    /**
     * Remove cookies from jobs table
     */
    async function removeCookies(jobId) {
        const url = `api/scrapery/job-cookies/${jobId}`
        console.log('Start removed');

        return await api.put(url)
    }

    /**
     * Schedule a job to run in the scrapy spiders
     * @param {number} jobId id of the job to schedule
     */
    async function scheduleRunJob(jobId) {
        const url = `/api/scrapery/run-jobs/${jobId}`

        return await api.get(url)
    }

    /**
     * Schedule details spider to run
     */
    async function runDetails(jobId) {
        const url = `/api/scrapery/run-details/${jobId}/2`

        return await api.get(url)
    }
    async function runCompanyDetails(jobId) {
        const url = `/api/scrapery/run-company-details/${jobId}/2`

        return await api.get(url)
    }
    /**
     * Schedule collection of emails
     * @param {number} jobId job id to run
     * @returns success/error
     */
    async function collectEmails(jobId) {
        const url = `/api/scrapery/run-details/${jobId}/3`

        return await api.get(url)
    }

    /**
     * Delete a job
     */
    async function deleteJob(jobId) {
        const url = `api/scrapery/jobs/${jobId}`

        return await api.delete(url)
    }

    /**
     * Pause a job
     */
    async function cancelJob(jobId) {
        const url = `/api/scrapery/cancel-jobs/${jobId}`;

        return await api.get(url);
    }

    /**
     * Generates
     * 
     * @param {number} jobId id of the job to find
     */
    async function generateOutputs(jobId) {
        const url = `api/automation/jobs/${jobId}/generate-donwloads`

        return await api.get(url)
    }

    /**
     * stopSpider
     *
     * @param {number} id of the job to find
     */
    async function stopSpider(jobId) {
        const url = `api/automation/jobs/${jobId}/stop-job`

        return await api.get(url)
    }



    /**
     * Generates
     * 
     * @param {number} jobId id of the job to find
     */
    async function dispatchJob(jobId) {
        const url = `api/automation/jobs/${jobId}/dispatch-job`

        return await api.get(url)
    }

    /**
     * Generates
     * 
     * @param {number} jobId id of the job to find
     */
    async function reRunJob(jobId) {
        const url = `api/automation/jobs/${jobId}/re-run-job`

        return await api.get(url)
    }


    /**
     * Generates
     * 
     * @param {number} jobId id of the job to find
     */
    async function runFailedTask(jobId) {
        const url = `api/automation/jobs/${jobId}/retry-job`

        return await api.get(url)
    }


    /**
     * Generates
     * 
     * @param {number} jobId id of the job to find
     */
    async function pauseJob(jobId) {
        const url = `api/automation/jobs/${jobId}/pause-job`

        return await api.get(url)
    }

    /**
     * Restart a task
     * 
     * @param {number} task_id id of the job to find
     */
    async function restartTask(task_id) {
        const url = `api/automation/tasks/${task_id}/restart-task`

        return await api.get(url)
    }

    /**
     * Restart a email collection spider
     * 
     * @param {number} job_id id of the job to find
     */
    async function reRunEmailCollection(job_id) {
        const url = `api/automation/jobs/${job_id}/re-run-email-collection`

        return await api.get(url)
    }

    /**         
    * Get a task details
    * 
    * @param {number} task_id id of the task to find
   */

    async function taskDetails(task_id) {
        const url = `api/scrapery/jobs/tasks/${task_id}`

        return await api.get(url)
    }
    async function saveComments(jobId, commentString) {
        const url = `api/scrapery/job-comments/${jobId}`

        const data = new FormData()
        data.append("comment", commentString)
        return await api.post(url, data)
    }

    /**
    * updateJob with concurrancy factor
    *
    * @param {number} job_id id of the job to find
    */
    async function updateJob(jobId, concurrency) {
        const url = `api/scrapery/jobs/${jobId}`
        const data = new FormData()

        data.append('concurrency_factor', concurrency)

        return await api.put(url, data)

    }
    /**
     * deletejoboutput with id
     *
     * @param {number} job_id id of the job to find
     */
    async function deletejoboutput(jobId) {
        const url = `api/scrapery/jobsoutput/${jobId}`


        return await api.delete(url)

    }
    /**
     * Create Dynamic Job
     */
    async function createDynamicJob(job) {
        const url = "api/automation/dynamic-job"
        const {
            segments,
            tool,
            type,
            name,
            description
        } = job

        const data = new FormData()

        data.append("segments", segments)
        data.append("tool", tool)
        data.append("type", type)
        data.append("name", name)
        data.append("description", description)

        return await api.post(url, data)
    }

    async function loadall(jobId) {
        const url = `api/scrapery/jobs/${jobId}?full=true`

        return await api.get(url)
    }

}

export default JobsAPI